import { Fragment } from 'react';
import { KeenIcon } from '@/components';
import { toAbsoluteUrl } from '@/utils/Assets';
import { CommonHexagonBadge } from '@/partials/common';

interface IntroProps {
    mode: 'create' | 'addSource';
}

const Intro = ({ mode }: IntroProps) => {
    // Define dynamic text based on the mode.
    const title =
        mode === 'create'
            ? 'Adding a Candidate to a Job Has Never Been Easier!'
            : 'Enhance Candidate Profile with Additional Sources';

    const description =
        mode === 'create'
            ? "Seamlessly add candidates to jobs in Buddy using various convenient methods. Upload a candidate's resume or CV, paste their details as plain text, or link to their online profile from platforms like LinkedIn or personal websites. Buddy processes the information, structures it into a comprehensive profile, and connects it with relevant job openings. You can even import candidate profiles from popular ATS platforms, making the process effortless and efficient."
            : "Elevate the candidate’s profile by integrating supplementary data from multiple sources. Whether it’s an updated resume, portfolio link, or social media profile, adding these insights enriches the candidate’s story and provides recruiters with a more nuanced view of their professional journey.";

    return (
        <Fragment>
            <style>
                {`
          .upgrade-bg {
            background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-5.png')}');
          }
          .dark .upgrade-bg {
            background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-5-dark.png')}');
          }
        `}
            </style>

            <div className="card rounded-xl">
                <div className="flex items-center justify-between grow gap-2 p-5 [background-position:121%_41%] bg-no-repeat bg-[length:660px_310px] upgrade-bg">
                    <div className="flex items-center gap-4">
                        <CommonHexagonBadge
                            stroke="stroke-success-clarity"
                            fill="fill-success-light"
                            size="size-[50px]"
                            badge={<KeenIcon icon="information-4" className="text-xl text-success" />}
                        />
                        <div className="flex flex-col gap-1.5">
                            <div className="flex items-center gap-2.5">
                                <a
                                    href="#"
                                    className="text-base font-medium text-gray-900 hover:text-primary-active"
                                >
                                    {title}
                                </a>
                            </div>
                            <div className="text-2sm text-gray-800">{description}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export { Intro };
